import { call, put, takeLatest } from 'redux-saga/effects';
import * as Actions from './actions';
import * as Apis from './service';

export function* getUserAccessPolicies() {
  try {
    const data = yield call(Apis.retrieveUserAccessPolicies);
    yield put(Actions.setUserAccessPolicies(data));
  } catch (error) {
    yield put(Actions.userAccessPoliciesRetrievalFailed(error));
  }
}

export function* watchGetUserAccessPolicyRequests() {
  yield takeLatest(Actions.UserAccessPoliciesActionTypes.USER_ACCESS_POLICIES_INIT, getUserAccessPolicies);
}
